'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import React from 'react'

// walrus
import Box, { BoxProps } from '../../kit/box'
import Text from '../../kit/text'

// lib
import { ThemeColor } from '../_support'

/* -----------------------------------------------------------------------------
 * PriorityTag
 * -------------------------------------------------------------------------- */

export type PriorityTagProps = BoxProps & {
  bgColor: ThemeColor
  label: string
  labelColor: ThemeColor
}

function PriorityTag({
  bgColor,
  label,
  labelColor,
  ...otherProps
}: PriorityTagProps) {
  return (
    <Box
      alignSelf='flex-start'
      bg={bgColor}
      borderRadius='proXs'
      px='08'
      py='04'
      {...otherProps}
    >
      <Text font='pro.text.12.semibold' textColor={labelColor}>
        {label}
      </Text>
    </Box>
  )
}

export default PriorityTag
